import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Table } from 'antd';

const MarkdownAnswer = ({ content }) => {
  // Custom component for rendering markdown tables as Ant Design tables
  const components = {
    table: ({ children }) => {
      // Parse the table from markdown
      const rows = [];
      let headers = [];
      let isHeader = true;
      
      React.Children.forEach(children, (child) => {
        if (child && child.type === 'thead') {
          React.Children.forEach(child.props.children, (row) => {
            if (row && row.type === 'tr') {
              headers = [];
              React.Children.forEach(row.props.children, (cell, idx) => {
                headers.push({
                  title: cell.props.children,
                  dataIndex: `col${idx}`,
                  key: `col${idx}`,
                  width: 200
                });
              });
            }
          });
        } else if (child && child.type === 'tbody') {
          React.Children.forEach(child.props.children, (row) => {
            if (row && row.type === 'tr') {
              const rowData = {};
              React.Children.forEach(row.props.children, (cell, idx) => {
                rowData[`col${idx}`] = cell.props.children;
              });
              rows.push(rowData);
            }
          });
        }
      });

      return headers.length > 0 ? (
        <Table 
          dataSource={rows} 
          columns={headers}
          pagination={false}
          size="small"
          style={{ marginBottom: '16px', marginTop: '16px' }}
          bordered
        />
      ) : (
        <table style={{ 
          borderCollapse: 'collapse', 
          width: '100%',
          marginBottom: '16px',
          marginTop: '16px'
        }}>
          {children}
        </table>
      );
    },
    // Style regular text content
    p: ({ children }) => <p style={{ marginBottom: '12px', lineHeight: '1.6' }}>{children}</p>,
    h1: ({ children }) => <h2 style={{ marginTop: '16px', marginBottom: '8px' }}>{children}</h2>,
    h2: ({ children }) => <h3 style={{ marginTop: '12px', marginBottom: '6px' }}>{children}</h3>,
    h3: ({ children }) => <h4 style={{ marginTop: '10px', marginBottom: '4px' }}>{children}</h4>,
    ul: ({ children }) => <ul style={{ marginLeft: '20px', marginBottom: '12px' }}>{children}</ul>,
    ol: ({ children }) => <ol style={{ marginLeft: '20px', marginBottom: '12px' }}>{children}</ol>,
    li: ({ children }) => <li style={{ marginBottom: '4px' }}>{children}</li>,
    code: ({ children }) => (
      <code style={{ 
        backgroundColor: '#f5f5f5', 
        padding: '2px 6px', 
        borderRadius: '4px',
        fontFamily: 'monospace'
      }}>
        {children}
      </code>
    ),
    blockquote: ({ children }) => (
      <blockquote style={{ 
        borderLeft: '4px solid #0B3D91',
        paddingLeft: '12px',
        marginLeft: 0,
        marginBottom: '12px',
        color: '#666'
      }}>
        {children}
      </blockquote>
    ),
  };

  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
      {content}
    </ReactMarkdown>
  );
};

export default MarkdownAnswer;
